export default "__VITE_ASSET__CMK3ekiF__"